import { useTranslation } from "react-i18next";

import {
  getCalendarIntegrationType,
  getDisplayCalendarSyncTile,
  getIsUpdatingCalendarConsent,
  updateUserClosedConsentTilePreference,
  useAppDispatch,
  useAppSelector,
  withAsyncThunkErrorHandling,
} from "@lib/store";
import { Button, IconButton } from "@molecules";

import { useConnectCalendar } from "../shared/useConnectCalendar";

// At the top of the sidebar on wide screens, under the app header on phones
export const HaNCalendarSyncTile = () => {
  const isShown = useAppSelector(getDisplayCalendarSyncTile);

  if (!isShown) return null;

  return <HaNCalendarSyncTileContent />;
};

const HaNCalendarSyncTileContent = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const calendarIntegrationType = useAppSelector(getCalendarIntegrationType);
  const isUpdatingCalendarConsent = useAppSelector(getIsUpdatingCalendarConsent);
  const connectCalendar = useConnectCalendar();

  const dismiss = () => {
    dispatch(withAsyncThunkErrorHandling(() => updateUserClosedConsentTilePreference(true)));
  };

  return (
    <div
      data-testid="organisms-hereAndNow-calendarSyncTile-wrapper"
      className="col-start-1 row-start-1 flex h-[176px] items-center bg-connecting-green-500* px-5 py-6 text-white max-sm:row-start-2">
      <div className="flex flex-1 flex-col items-start gap-4">
        <div className="flex flex-col gap-1">
          <p className="font-semibold">{t("hereAndNow:ConsentBannerTitle")}</p>
          <p>{t("hereAndNow:ConsentBannerMessage")}</p>
        </div>
        <Button
          button="primary light"
          data-testid="organisms-calendar-CalendarEventsList_connect-calendar-button-banner"
          loading={isUpdatingCalendarConsent}
          disabled={isUpdatingCalendarConsent}
          onClick={connectCalendar}>
          {t("meeting:CalendarBannerButton", { calendarIntegrationType })}
        </Button>
      </div>
      <IconButton
        className="self-start"
        data-testid="organisms-calendar-CalendarEventsList_close-connect-calendar-button-banner"
        aria-label={t("translation:Close")}
        icon="close"
        iconButton="tertiary light"
        onClick={dismiss}
        size="small"
      />
    </div>
  );
};
